module.exports = __webpack_public_path__ + "static/media/01.05bde549.mp3";